var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "view-point-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: _vm.funcName + " " + _vm.form.info,
            visible: _vm.dialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("el-card", { staticClass: "box-card" }, [
            _c(
              "div",
              { staticStyle: { position: "relative", height: "80%" } },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading",
                      },
                    ],
                    staticStyle: { width: "100%" },
                    attrs: {
                      size: "mini",
                      data: _vm.form.formTable,
                      border: "",
                      fit: "",
                      "highlight-current-row": "",
                      height: "100%",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: "項次",
                        width: "60",
                        fixed: "left",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: "ID",
                        width: _vm.form.formChk ? 250 : 160,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-tag",
                                { attrs: { size: "mini", type: "info" } },
                                [_vm._v(_vm._s(row.identity))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    !_vm.form.formChk
                      ? _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "姓名",
                            width: "160",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-tag",
                                      { attrs: { size: "mini", type: "info" } },
                                      [_vm._v(_vm._s(row.name))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4223626515
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: "加入時間",
                        width: "160",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-tag",
                                { attrs: { size: "mini", type: "success" } },
                                [_vm._v(_vm._s(row.joinTime))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "領隊", width: "160" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              row.isTravelLeader
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "mini", type: "success" },
                                    },
                                    [_vm._v("V")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { padding: "20px", "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            { staticClass: "filter-form", attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "旅行社" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "請選擇旅行社",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listQuery.agencyCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "agencyCode", $$v)
                        },
                        expression: "listQuery.agencyCode",
                      },
                    },
                    _vm._l(_vm.agencyList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.val, value: item.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "團號" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "輸入團號" },
                    model: {
                      value: _vm.listQuery.qry,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "qry", $$v)
                      },
                      expression: "listQuery.qry",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "團名" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "輸入團名" },
                    model: {
                      value: _vm.listQuery.qrySecond,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "qrySecond", $$v)
                      },
                      expression: "listQuery.qrySecond",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "250px" },
                  attrs: { label: "出發區間" },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "daterange",
                      align: "right",
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "開始日期",
                      "end-placeholder": "結束日期",
                      "picker-options": _vm.pickerOptions,
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.listQuery.dateFilter,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "dateFilter", $$v)
                      },
                      expression: "listQuery.dateFilter",
                    },
                  }),
                ],
                1
              ),
              _c("el-button", {
                staticStyle: { cursor: "pointer", "margin-left": "20px" },
                attrs: {
                  type: "success",
                  loading: _vm.listLoading,
                  circle: "",
                  icon: "el-icon-refresh-left",
                },
                on: {
                  click: function ($event) {
                    return _vm.refresh()
                  },
                },
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "8px", "margin-left": "20px" },
                  attrs: {
                    size: "medium",
                    type: "danger",
                    icon: "el-icon-download",
                    disabled: _vm.listLoading,
                  },
                  on: { click: _vm.getExcel },
                },
                [_vm._v(" EXCEL下載 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c("el-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              size: "mini",
              data: _vm.list,
              border: "",
              fit: "",
              "highlight-current-row": "",
              height: "100%",
            },
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }